import { Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { AlertComponent } from 'src/app/shared/components/ui/alert/alert.component';
import { ModalComponent } from 'src/app/shared/components/modals/modal/modal.component';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';

@Component({
  selector: 'bizz-duplicate-resultclass-warning',
  standalone: true,
  imports: [
    AlertComponent,
    ModalComponent,
    TranslatePipe
  ],
  templateUrl: './duplicate-resultclass-warning.component.html',
  styleUrl: './duplicate-resultclass-warning.component.scss'
})
export class DuplicateResultclassWarningComponent {
  public dialogRef = inject(DialogRef);
}
